import {
  CustomerIndex,
  CustomerEditor,
  CustomerAccountIndex,
  CustomerAccountProductIndex
} from "../views";
export const customerAccountRouter = [
  {
    path: "customer",
    name: "CustomerIndex",
    component: CustomerIndex
  },
  {
    path: "customer/edit/:id?",
    name: "CustomerEditor",
    component: CustomerEditor,
    props: true,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: "customerAccountIndex",
    name: "CustomerAccountIndex",
    component: CustomerAccountIndex
  },
  {
    path: "customerAccountProductIndex",
    name: "CustomerAccountProductIndex",
    component: CustomerAccountProductIndex
  }
];
